import { render, staticRenderFns } from "./SiteTreeContentArea.vue?vue&type=template&id=1a2b256c&scoped=true"
import script from "./SiteTreeContentArea.vue?vue&type=script&lang=js"
export * from "./SiteTreeContentArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2b256c",
  null
  
)

export default component.exports